import SuccessIcon from "../../../../assets/images/assessment-success.svg";
import FailIcon from "../../../../assets/images/pre-assessment.svg";
import CheckIcon from "../../../../assets/images/assessment-check.svg";
import CrossIcon from "../../../../assets/images/assessment-x.svg";

import Modal from "../../../modal/Modal";

import { LMS_COURSE_NAME } from "../../../../utils/cookiesmanager";

import styles from "./styles.module.scss";
import { BUTTON_VARIANTS } from "../constant";
import Button from "../ButtonComponent";
import { useGetTranslatedText } from "../queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const CourseStatusModal = (props) => {
  const {
    show,
    marks,
    handleContinue,
    handleTryAgain,
    passingMarks = 50,
    handleExit,
  } = props;

  const moduleName = localStorage.getItem(LMS_COURSE_NAME);

  const userData = JSON.parse(localStorage.getItem("user")) || {};

  const { userTypeId } = userData || {};

  const languageId = localStorage.getItem("l_id") || 1;

  const { data: translatedTextResponse } = useGetTranslatedText(languageId);

  const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
          {marks?.percentage >= passingMarks ? (
            <div className={styles["success-image"]}>
              <img src={SuccessIcon} alt="success" />
            </div>
          ) : (
            <div className={styles["success-image"]}>
              <img src={FailIcon} alt="fail" />
            </div>
          )}
          {marks?.percentage >= passingMarks ? (
            <div className={styles.title}>
              {getTranslatedText(
                translatedText,
                "key_congratulation",
                "Congratulations",
              )}
            </div>
          ) : (
            <div className={styles.title}>
              {getTranslatedText(translatedText, "key_try_again", "Try again!")}
            </div>
          )}

          {marks?.percentage >= passingMarks ? (
            <div className={styles.description}>
              You have completed {moduleName} . you score
              <span
                className={`${styles["numeric-result"]} ${
                  marks?.percentage < passingMarks ? styles["low-score"] : ""
                }`}
              >
                {" "}
                {`${marks?.percentage || 0}%`}
              </span>
            </div>
          ) : (
            <div className={styles.description}>
              You need
              <span
                className={`${styles["numeric-result"]} ${
                  marks?.percentage < passingMarks ? styles["high-score"] : ""
                }`}
              >
                {" "}
                {userTypeId === 12 ? 70 : passingMarks}%
              </span>
              or above to complete module assessment. We encourage you to review
              the course and come back for another attempt.
            </div>
          )}

          <div className={styles["result-wrapper"]}>
            {marks?.result?.map((item, index) => (
              <div className={styles.result} key={item.id}>
                {item?.isCorrect === 1 ? (
                  <div className={styles["result-check"]}>
                    <img src={CheckIcon} alt="check" />
                  </div>
                ) : (
                  <div className={styles["result-cross"]}>
                    <img src={CrossIcon} alt="cross" />
                  </div>
                )}

                <div>Question {index + 1}</div>
              </div>
            ))}
          </div>
          {marks?.percentage >= passingMarks ? (
            <div className={styles["button-wrapper"]}>
              {/* <button className={styles.button} onClick={handleContinue}>Continue</button> */}
              <Button
                label={getTranslatedText(
                  translatedText,
                  "label_continue",
                  "Continue",
                )}
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                className={styles.button}
                onClick={handleContinue}
              />
            </div>
          ) : (
            <div className={styles["button-wrapper"]}>
              {/* <button className={styles.button} onClick={handleTryAgain}>Try again!</button>
              <button className={styles.button} onClick={handleTryAgain}>Try again!</button> */}
              <Button
                label={getTranslatedText(
                  translatedText,
                  "key_btn_exit",
                  "Exit",
                )}
                buttonVariant={BUTTON_VARIANTS.SECONDARY}
                className={styles["exit-button"]}
                onClick={handleExit}
              />
              <Button
                label={
                  getTranslatedText(
                  translatedText,
                  "key_try_again",
                  "Try Again",
                )}
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                className={styles.button}
                onClick={handleTryAgain}
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CourseStatusModal;
